import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateWithKeysPipe } from './translateWithKeys/translate-with-keys.pipe';
import { TimeFormatPipe } from './time-format/time-format.pipe';
import { TruncatePipe } from './truncate/truncate.pipe';
import { CustomTitleCasePipe } from './custom-title-case/custom-title-case.pipe';
import { ThumbnailPipe } from './thumbnail/thumbnail.pipe';
import { PrettifyJsonPipe } from './prettify-json/prettify-json.pipe';
import { AppDatePipe } from './appDate/app-date.pipe';
import { FileSizePipe } from './fileSize/file-size.pipe';
import { MarkdownPipe } from './markdown/markdown.pipe';



@NgModule({
  declarations: [TranslateWithKeysPipe, TimeFormatPipe, TruncatePipe, CustomTitleCasePipe, ThumbnailPipe, PrettifyJsonPipe, AppDatePipe, FileSizePipe, MarkdownPipe],
  imports: [
    CommonModule
  ],
  exports: [TranslateWithKeysPipe, TimeFormatPipe, TruncatePipe, CustomTitleCasePipe, ThumbnailPipe, PrettifyJsonPipe, AppDatePipe, FileSizePipe, MarkdownPipe]
})
export class PipesModule { }
